module.exports = __webpack_public_path__ + "img/no_budget.92d0afa0.png";